import { AccountCard, OperationalCard } from './components';

function Skeleton(): JSX.Element {
  return (
    <>
      <AccountCard.Skeleton />
      <OperationalCard.Skeleton />
    </>
  );
}

export default Skeleton;
